const validatePhone = (rule, value, callback) => {
  const patter = new RegExp('^1[0-9]{10}$');
  if (!patter.test(value)) {
    return callback(new Error('请输入正确格式的手机号！'));
  }
  return callback();
};

export default {
  common: {
    mobilePhone: [{
      required: true,
      message: '手机号不能为空',
    }, {
      validator: validatePhone,
      trigger: 'blur',
      message: '请输入正确的证件号',
    }],
  },
  softwareApply: {
    seat: [{ whitespace: true, required: true, message: ' ' }],
    companyName: [{ required: true, message: ' ' }],
    phone: [{ whitespace: true, required: false, message: ' ' }],
    location: [{ required: true, message: ' ' }],
    softwareName: [{ whitespace: true, required: true, message: ' ' }],
    deskCode: [{ whitespace: true, required: true, message: ' ' }],
  },
};
